// extracted by mini-css-extract-plugin
module.exports = {"cardVersaoPro":"LimitacoesCards_cardVersaoPro__1XffK"};